export default "__VITE_ASSET__rh9biC5b__"